'use strict'

var convert = require('hast-util-is-element/convert')

module.exports = convert([
  'audio',
  'canvas',
  'embed',
  'iframe',
  'img',
  'math',
  'object',
  'picture',
  'svg',
  'video'
])



//////////////////
// WEBPACK FOOTER
// ./node_modules/hast-util-embedded/index.js
// module id = L93H
// module chunks = 0